import { Grid } from '@mairistem/composants';
import { formatMontant } from '@mairistem/finances-utils';
import React from 'react';
import type PanelProps from '../../../interfaces/simulation/panelProps';
import { getSoldeClass } from '../../../utils/simulation/panel';

const BalanceInvestissement = ({ data }: PanelProps) => {
	const solde =
		(data?.recetteInvestissement ?? 0) - (data?.depenseInvestissement ?? 0);
	const soldeClass = getSoldeClass(solde);

	return (
		<Grid>
			<Grid.Row>
				<Grid.Column className="bold indicateurTitle">
					Investissement
				</Grid.Column>
			</Grid.Row>
			<Grid.Row>
				<Grid.Column width={10}>
					<div>Dépense</div>
					<div>Recette</div>
				</Grid.Column>
				<Grid.Column width={6} textAlign="right">
					<div data-testid="depenseInvestissement">
						{formatMontant(data?.depenseInvestissement ?? 0)}
					</div>
					<div data-testid="recetteInvestissement">
						{formatMontant(data?.recetteInvestissement ?? 0)}
					</div>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className={soldeClass?.join(' ')}>
				<Grid.Column width={10}> Solde </Grid.Column>
				<Grid.Column
					width={6}
					textAlign="right"
					data-testid="soldeInvestissement"
				>
					{formatMontant(solde)}
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

export default BalanceInvestissement;
